import React from 'react';
import homeIcon from '../asset/homeIcon.png';
import { Link, useLocation } from 'react-router-dom';

const HeaderAbout = ({ onLanguageChange, language }) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  return (
    <header className="header">
      <div className="logo-container">
        <Link to={`/?lang=${language}`}>
          <img src={homeIcon} alt="Uni Studio" className="homeIcon" />
        </Link>
      </div>
      <div>
        <span className="about-title">About Uni Studio</span>
      </div>
      <div className="lang-toggle">
        <button
          onClick={() => onLanguageChange('en')}
          className={language === 'en' ? 'active' : ''}
        >
          EN
        </button>
        <button
          onClick={() => onLanguageChange('ko')}
          className={language === 'ko' ? 'active' : ''}
        >
          KR
        </button>
      </div>
    </header>
  );
}

export default HeaderAbout;
